export type {
  Blueprint,
  BlueprintLockedSection,
  BlueprintOutputAccess,
  BlueprintOutputTier,
  BlueprintStatus,
  GeneratedBlueprintOutput,
  GuidedAnswers,
  GuidedFollowUpAnswer,
  GuidedFollowUpAnswers,
  GuidedFollowUpId,
  GuidedQuestionId,
  GuidedUnsureFlags,
  TargetBuilder,
} from "@shared/types";

export const TARGET_BUILDERS = [
  { value: "universal", label: "Universal Builder" },
  { value: "replit", label: "Replit" },
  { value: "lovable", label: "Lovable" },
  { value: "base44", label: "Base44" },
  { value: "bolt", label: "Bolt" },
  { value: "abacus", label: "Abacus" },
  { value: "cursor", label: "Cursor" },
  { value: "v0", label: "v0" },
  { value: "claude_code", label: "Claude Code" },
] as const;

export const BLUEPRINT_INPUT_MAX_LENGTH = 5000;
